import {
	Vue, Component, Ref, toNative,
} from 'vue-facing-decorator';
import ThemeEditPageTable from 'components/Themes/ThemesTable/ThemeEditPageTable';
import { useRoute, useRouter } from 'vue-router';
import Template from './template.vue';

@Component({
	components: {
		ThemeEditPageTable,
	},
	mixins: [Template],
})
class ThemeEditPage extends Vue {
	@Ref('themeeditpage')
	private readonly theme!: HTMLFormElement;

	private route = useRoute();

	private router = useRouter();

	protected routeTemplate(id: string): void {
		this.router.push(`/template/${id}`);
	}

	protected routeLayout(id: string): void {
		this.router.push(`/layout/${id}`);
	}

	protected routePageObject(id: string): void {
		this.router.push({
			name: 'PageObject',
			params: {
				objectid: id,
				id: this.route.params.id,
				pageid: this.route.params.pageid,
			},
		});
	}

	protected updateThemeEditProperties(): void {
		this.theme.editTheme();
	}
}

export default toNative(ThemeEditPage);
